import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const InfoPage = lazyWithRetry(() => import("./ui/pages/InfoPage"), "InfoPage");

/**
 * Rutas de landing (páginas informativas)
 */
const landingRoutes = buildRoutes([
  {
    path: "/homepage",
    element: InfoPage,
    roles: [4, 5],
  },
]);

export default landingRoutes;
